// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import AdminLayout from "./admin/AdminLayout";
// import AdminLogin from "./admin/AdminLogin";
// import Dashboard from "./admin/Dashboard";
// import Users from "./admin/Users";
// import ProtectedRoute from "./admin/ProtectedRoute";
// import Subjects from "./admin/Subjects";
// import Topics from "./admin/Topics";
// // import Stories from "./admin/Stories";
// import StoriesList from "./admin/stories/StoryAll";
// import StoryEdit from "./admin/stories/StoryEdit";
// import StoryCreate from "./admin/stories/StoryCreate";
// import Subscriptions from "./admin/Subscriptions";

// export default function App() {
//   return (
//     <BrowserRouter>
//       <Routes>
//         {/* Public */}
//         <Route path="/login" element={<AdminLogin />} />

//         {/* Protected Admin */}
//         <Route
//           path="/"
//           element={
//             <ProtectedRoute>
//               <AdminLayout />
//             </ProtectedRoute>
//           }
//         >
          
//           <Route index element={<Dashboard />} />
//           <Route path="users" element={<Users />} />
//           <Route path="subjects" element={<Subjects/>}/>
//           <Route path="topics/:slug" element={<Topics/>}/>
//          <Route path="stories/:topicId" element={<StoriesList />} />
//          <Route path="/stories/edit/:id" element={<StoryEdit />} />
//           <Route path="/stories/:topicId/new" element={<StoryCreate />} />
//           <Route path="/subscriptions" element={<Subscriptions/>}/>
//          {/* /stories/edit/ */}


//         </Route>
//       </Routes>
//     </BrowserRouter>
//   );
// }

import { BrowserRouter, Routes, Route } from "react-router-dom";
import AdminLayout from "./admin/AdminLayout";
import AdminLogin from "./admin/AdminLogin";
import Dashboard from "./admin/Dashboard";
import Users from "./admin/Users";
import ProtectedRoute from "./admin/ProtectedRoute";
import Subjects from "./admin/Subjects";
import Topics from "./admin/Topics";
import StoriesList from "./admin/stories/StoryAll";
import StoryEdit from "./admin/stories/StoryEdit";
import StoryCreate from "./admin/stories/StoryCreate";
import Subscriptions from "./admin/Subscriptions";
import UserSubscriptions from "./admin/UserSubscriptions"; // ✅ add this

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<AdminLogin />} />

        {/* Protected Admin */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />

          <Route path="users" element={<Users />} />
          <Route path="subjects" element={<Subjects />} />
          <Route path="topics/:slug" element={<Topics />} />

          <Route path="stories/:topicId" element={<StoriesList />} />
          <Route path="stories/edit/:id" element={<StoryEdit />} />
          <Route path="stories/:topicId/new" element={<StoryCreate />} />

          <Route path="subscriptions" element={<Subscriptions />} />

          {/* ✅ new route */}
          <Route path="user-subscriptions" element={<UserSubscriptions />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}